// Matches the backend enum StatEventType
export enum StatEventType {
    IMAGE_GENERATION_STARTED = "IMAGE_GENERATION_STARTED",
    IMAGE_GENERATED = "IMAGE_GENERATED",
    IMAGE_GENERATION_FAILED = "IMAGE_GENERATION_FAILED",
    IMAGE_DOWNLOADED = "IMAGE_DOWNLOADED",
    IMAGE_SHARED = "IMAGE_SHARED",
    ASSET_UPLOADED = "ASSET_UPLOADED",
    ASSET_UPLOAD_START = "ASSET_UPLOAD_START",
    ASSET_UPLOAD_FAILED = "ASSET_UPLOAD_FAILED",
    TOKEN_REFRESH_NETWORK_ERROR = "TOKEN_REFRESH_NETWORK_ERROR",
}

// You can define frontend-specific event payload interfaces if needed
export interface FrontendLogEventPayload {
    eventType: StatEventType;
    templateId?: string;
    templateName?: string;
    designKey?: string;
    designName?: string;
    generationId?: string;
    // Add other fields that the frontend might send
}

